import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UtilityService } from '../utility.service';
import { BaseFormService } from '../BaseFormService';
import { AverageAccountBalanceResult } from 'app/models/general-ledger/InvestmentIncomeAllocationView';

@Injectable({
	providedIn: 'root',
})
export class InvestmentIncomeAllocationService extends BaseFormService {
	constructor(httpClient: HttpClient, utilityService: UtilityService) {
		super(
			`${environment.apiUrl}forms/clients/$$clientId$$/investment-income-allocation-form`,
			httpClient,
			utilityService
		);
	}

	getFormsForClient(clientId: string): Observable<any[]> {
		return this.httpClient.get<any[]>(`${this.getUrl(clientId)}/GetPreApprovalByClient`).pipe();
	}

	submitForApproval(clientId: string, id: any, userId: string): Observable<any> {
		return this.httpClient
			.post<any>(`${this.getUrl(clientId)}/${id}/approval`, {
				userId,
			})
			.pipe();
	}

	getAverageAccountBalance(clientId: string, request: any): Observable<any> {
		return this.httpClient.post<any>(`${this.getUrl(clientId)}/getAverageAccountBalance`, request).pipe();
	}
	getPooledCashBalanceEntries(clientId: string, request: any): Observable<any> {
		return this.httpClient.post<any>(`${this.getUrl(clientId)}/pooledCashBalanceEntries`, request).pipe();
	}

	getRecurringForms(clientId: string): Observable<any[]> {
		return this.httpClient.get<any[]>(`${this.getUrl(clientId)}/recurring-forms`).pipe();
	}

	getBatchAverageBalances(clientId: string, filters: any[]): Observable<AverageAccountBalanceResult[]> {
		return this.httpClient.post<any>(`${this.getUrl(clientId)}/getAverageAccountBalances`, filters).pipe();
	}
}
